module.exports = __webpack_public_path__ + "static/img/bg72.29361dc2.png";